// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","footer_inner":"Footer_footer_inner__ubr06","text_button":"Footer_text_button__l2cos"};